import {AD_BASE_URL, AD_SCRIPT_VERSION} from '../config/constants';
import {Utils} from '../support/utils';

export class AdLoader {


    constructor(context) {
        this.context = context;
    }

    get(parameters) {
        const requestParameters = this.prepareRequestParameters(parameters);
        const baseUrl = parameters['service'] || AD_BASE_URL;
        const url = baseUrl + '?' + Utils.toQueryParams(requestParameters);
        return fetch(url);
    }

    prepareRequestParameters(parameters)
    {
        let bluestackUserId = null;
        let queryParameters = {
            p : escape(document.location),
            random:  Math.random(),
            rt : 'javascript' + (parameters.withMediation ? '_mediation' : ''),
            v : AD_SCRIPT_VERSION,
            locale:  Utils.getNavigatorLanguage(this.context),
            jsvar: parameters.containerId,
            u: navigator.userAgent
        };

        for (const [ key, value ] of Object.entries(parameters)) {
            if (['backfillhtml' , 'userid' , 'onError' , 'withMediation' , 'containerId' , 'size', "position"].includes(key)) {
                continue;
            }
            queryParameters[key] = escape(value.toString());
        }

        let iframeSize = this.getIframeSize(parameters.format) ;
        if (iframeSize.w && iframeSize.h) {
            queryParameters = Object.assign(queryParameters, iframeSize);
        }

        if(parameters.userid) {
            if(/(android)/i.test(navigator.userAgent)) {
                queryParameters['o[andadvid]'] = parameters.userid;
            }
            else if(/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                queryParameters['o[idfa]'] = parameters.userid;
            }
        }

        if (parameters.mraid === true) {
            queryParameters['c_mraid'] = 1;
        }

        bluestackUserId = Utils.getCookie('maduserid');
        if (bluestackUserId) {
            queryParameters['o[userid]'] = bluestackUserId;
        }

        let cookies = document.cookie.split(';');
        for (let i = 0; i < this.context.document.length; i++) {
            let cookie = cookies[i].trim().split('=');
            if (cookie[0].match(/seenad\[\d+\]=\d+/)) {
                queryParameters[cookie[0]] = cookie[1];
            }
        }

        return queryParameters;
    }


    getIframeSize(format)
    {
        const size = {
            w: null,
            h: null
        }

        switch (format) {
            case 'interstitial':
                size.w = this.context.innerWidth;
                size.h = this.context.innerHeight;
                break;
            case 'square':
                size.w = 300;
                size.h = 250;
                break;
            case 'banner':
                size.w = this.context.innerWidth;
                size.h = window.innerWidth >= 768 ? 90 : 50;
                break;
        }

        return size;
    }

}